import {ComponentProps} from 'react';
import {Link} from 'react-router';

import {localize} from '@/shared/services/i18n';
import {localizeHref} from '@/sync/lib/localizeHref';

type CookieAgreementProps = ComponentProps<'p'>;

export function CookieAgreement(props: CookieAgreementProps) {
  return (
    <p {...props}>
      {localize('cookie_consent_initial_description')}&nbsp;
      {localize('request_idfa_privacy_reference')}
      <Link
        className="font-normal text-system-blue underline"
        to={localizeHref('/:lang?/privacy')}
        target="_blank"
        rel="noopener noreferrer"
      >
        {localize('_privacy_policy_instrumental')}
      </Link>
      {localize('legal_links_and')}
      <Link
        className="font-normal text-system-blue underline"
        to={localizeHref('/:lang?/cookie-policy')}
        target="_blank"
        rel="noopener noreferrer"
      >
        {localize('cookie_policy_link')}
      </Link>
    </p>
  );
}

export default CookieAgreement;
